import { render, staticRenderFns } from "./PuzzleWallsList.vue?vue&type=template&id=72b42488"
import script from "./PuzzleWallsList.vue?vue&type=script&lang=js"
export * from "./PuzzleWallsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports